import { generateId } from "@profilog/utils/generateId";
import { safeJsonParse } from "./safeJsonParse";

export function parseJsonArrayAddIds(text) {
    const json = safeJsonParse(text);
    if (json === null || !Array.isArray(json)) return null;
    return json.map((i) => ({ ...i, id: generateId() }));
}
